"use client"
import useIsMobile from "@core/helpers/client/hooks/useIsMobile";
import Mobile from "./Mobile"
import Desktop from "./Desktop"

const Index = (props) => {
	const is_mobile = useIsMobile();
	return (
		is_mobile ? <Mobile {...props} /> : <Desktop {...props} />
	)
}
export default Index